import { IIMaterielSearch, IMaterielDetail, IMaterielInsert, IMaterielUpdate, IMaterielRemove, IMaterielDisable } from "./materielTypes"
import { IPage, IMdCmFields } from "@/types/FmsTypes"
import { httpRequest } from "@/utils/HttpRequest"
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants"

class MaterielService {
    async page(params: IIMaterielSearch) {
        const apiUrl = "/material/page"
        return await httpRequest.post<IPage<IMaterielDetail>>(apiUrl, params)
    }
    async insert(params: IMaterielInsert) {
        const apiUrl = "/material/insert"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async update(params: IMaterielUpdate) {
        const apiUrl = "/material/update"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async remove(params: IMaterielRemove) {
        const apiUrl = "/material/remove"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async disable(params: IMaterielDisable) {
        const apiUrl = "/material/disable"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async sync(syncVo: IMdCmFields) {
        const apiUrl = "/material/sync";
        syncVo.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(apiUrl, syncVo,{ timeout: LONG_REQUEST_TIMEOUT })
    }
}
const materielService = new MaterielService()
export {
    materielService
}